export default "__VITE_ASSET__BAIdD6ib__"